import { Badge, Tooltip } from '@mantine/core'
import React from 'react'
import { colors } from '../../../settings/colors'
import { useIsWideScreen } from '../../../utils/useIsWideScreen'
import { getNodeStatusLabel, NODE_STATUS_COLORS } from '../Map/_utils/getActiveNodeStatus'
import { TNodeStatus } from '../types'

export const EquipmentStatusWithCountBadge: React.FC<{ status: TNodeStatus; count?: number }> = ({
  status,
  count,
}) => {
  const isWideScreen = useIsWideScreen()

  const wrapWithTooltip = (content: React.ReactNode, tooltip?: string | null): React.ReactNode => {
    return tooltip ? <Tooltip label={tooltip}>{content}</Tooltip> : content
  }

  // add tooltip for offline + pending status
  const tooltip =
    status === TNodeStatus.OFFLINE
      ? `${getNodeStatusLabel(TNodeStatus.OFFLINE)} + ${getNodeStatusLabel(TNodeStatus.PENDING)}`
      : null

  let countText = '-'

  if (count !== undefined) countText = count > 999 ? '999+' : count.toString()

  return (
    <div>
      <div
        style={{
          color: 'white',
          display: 'inline-block',
          marginRight: 10,
          fontSize: isWideScreen ? '30px' : '20px',
          lineHeight: '30px',
          fontWeight: 500,
        }}
      >
        {countText}
      </div>

      {wrapWithTooltip(
        <span>
          <Badge
            css={{
              color: colors.midnight,
              backgroundColor: NODE_STATUS_COLORS[status],
              fontSize: '12px',
              textTransform: 'none',
              verticalAlign: 'top',
              marginTop: 5,
            }}
          >
            {getNodeStatusLabel(status)}
          </Badge>
        </span>,
        tooltip,
      )}
    </div>
  )
}
